import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-market-study-inside',
  templateUrl: './market-study-inside.component.html',
  styleUrls: ['./market-study-inside.component.css']
})
export class MarketStudyInsideComponent implements OnInit {

  title: string = '';
  output: any[] = [];
  isLoader = false;

  constructor(
    private route: ActivatedRoute,
    private service: ServiceService
  ) {}

  ngOnInit(): void {
    // read which sub-route we are on
    this.route.url.subscribe(urlSegments => {
      const lastSegment = urlSegments[urlSegments.length - 1]?.path;

      if (lastSegment === 'decorative-coatings') {
        this.title = 'Decorative Coatings';
        this.loadData('Decorative Coatings');
      } else if (lastSegment === 'others') {
        this.title = 'Others';
        this.loadData('Others');
      }
    });
  }

  loadData(industryType: string): void {
    this.isLoader = true;
    // you can change this filter logic as per your API
    const query = `?industry_type=${industryType}`;
    this.service.viewMarketStudy(query).subscribe({
      next: (res) => {
        this.output = res.data;
        this.isLoader = false;
      },
      error: (err) => {
        console.error('Error loading Market Study data', err);
        this.isLoader = false;
      }
    });
  }
}
  